"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useIntentColor = void 0;

var _react = require("react");

var _styledComponents = require("styled-components");

var _intentColorSelector = require("../intentColorSelector");

/**
 * hook that fetches intent color out of theme
 *
 * @returns function that takes in an intent color and intensity and returns a color hex
 */
var useIntentColor = function useIntentColor() {
  // this is pulled outside of the return function so as to reduce reads from context
  var theme = (0, _react.useContext)(_styledComponents.ThemeContext);
  return function (intentColor, intensity) {
    return (0, _intentColorSelector.intentColorSelector)({
      theme: theme
    }, intentColor, intensity);
  };
};

exports.useIntentColor = useIntentColor;